import { debug } from "../../App";
import ApiService from "../../services/ApiService";
import Form from "../../types/Form";
import { MemberInterface } from "../../types/Member";

export const UpdateMemberRequest = (member: MemberInterface | null, form: Form, payload: any) => {
  const handler = form.handler.replace(":id", member!.id.toString());

  debug("UpdateMemberRequest", member, form, payload);

  // Profile Images
  if (form.id === 6) {
    const formData: FormData = new FormData();
    formData.set("form", String(form.id));
    Object.keys(payload).forEach((key) => formData.set(key, payload[key]));

    debug("UpdateMemberRequest formData", formData);

    return ApiService.post(handler, formData, {
      headers: {
        "Content-Type": false,
      },
    });
  } else {
    return ApiService.post(handler, {
      form: form.id,
      data: payload,
    });
  }
};
